import { shallowEqual, useSelector } from "react-redux";
import { NavLink, useParams } from "react-router-dom";
import {
  selectInformationOnIdentifier,
  selectNextId,
} from "../../../services/form/slices";
import { Mui, MuiIcons } from "@osu/react-ui";
import { selectIsAdmin } from "../../../services/authorization/slices";

function NextWidget(props = {}) {
  const { id } = useParams();
  const isAdmin = useSelector(selectIsAdmin);
  const nextId = useSelector((state) => selectNextId(state, id));
  const path = useSelector(
    (state) => selectInformationOnIdentifier(state, nextId)?.path,
    shallowEqual
  );

  if (!isAdmin || !path) {
    return false;
  }

  return (
    <Mui.Button
      variant="outlined"
      component={NavLink}
      color="inherit"
      size="small"
      to={path}
      {...props}
      endIcon={<MuiIcons.NavigateNext />}
    >
      Next Form
    </Mui.Button>
  );
}

export default NextWidget;
